import { render, staticRenderFns } from "./payment-button.vue?vue&type=template&id=fe7d2a88"
import script from "./payment-button.vue?vue&type=script&lang=js"
export * from "./payment-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports